import { CategoricalColumn } from 'baseui/data-table';

export const COL_NAMES = {
	startRange: 'start',
	endRange: 'end',
	offerPercentage: 'offerPercentage',
	cashbackPercentage: 'cashbackPercentage',
	bonusPercentage: 'bonusPercentage'
};

export const gstConfig = [
	CategoricalColumn({
		title: 'GST offer start range(₹)(Incl.)',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.startRange]?.toLocaleString('en-IN')
	}),
	CategoricalColumn({
		title: 'GST offer end range(₹)(Excl.)',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.endRange]?.toLocaleString('en-IN')
	}),
	CategoricalColumn({
		title: 'Offer Percentage(%)',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.offerPercentage] || '0'
	}),
	CategoricalColumn({
		title: 'Cashback Percentage(%)',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.cashbackPercentage] || '0'
	}),
	CategoricalColumn({
		title: 'Bonus Percentage(%)',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.bonusPercentage] || '0'
	})
];

export const DEFAULT_CONFIG = {
	pageDetails: {
		pageNo: 0,
		pageSize: 100
	},
	sortDetails: {
		sortField: 'code',
		sortOrder: 'ASC'
	}
};
